
export class SMSUsageReportData {

    constructor(
        public monthStartDate: string,
        public totalMessages: number
    ) { }
}
